"use strict";
class OperandValue {
    get HasOperandValue() {
        return this.Value != null;
    }
    ;
}
exports.OperandValue = OperandValue;
